import { Pipe, PipeTransform } from '@angular/core';

/**
 * Contagem e porcentagem em pt-BR (`12.480`, `28,6%`). O painel não registra o
 * locale pt-BR no Angular, então o `number` padrão sairia em inglês (`12,480`).
 * Ausência sai como travessão: zero é número, vazio não é.
 */
@Pipe({ name: 'rcsNumber' })
export class RcsNumberPipe implements PipeTransform {
  transform(value: number | null | undefined, kind: 'count' | 'percent' = 'count'): string {
    if (value === null || value === undefined || !isFinite(Number(value))) {
      return '—';
    }

    if (kind === 'percent') {
      return `${(Number(value) * 100).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;
    }

    return Math.round(Number(value)).toLocaleString('pt-BR');
  }
}
